import { Spinner } from '@nextui-org/react';
import React from 'react';

import ListUsecase from '@/app/template/ListUsecase';
import ListUsecaseProfile from '@/app/template/ListUsecaseProfile';
import useListLayout from '@/components/list-layout/useListLayout';
import NoData from '@/components/NoData';
import RenderWhen from '@/components/RenderWhen';
import { useAuth } from '@/provider/UserProvider';
import type { UserProfile } from '@/types/user';

import useUseCaseProfile from './useUseCaseProfile';

const UserUseCase: React.FC<{
  user: UserProfile;
}> = ({ user }) => {
  const { auth } = useAuth();
  const { type: typeLayout } = useListLayout();
  const { currentPage, artworks, loading, loadMore } = useUseCaseProfile(user.id);

  const [openFilter, setOpenFilter] = React.useState(false);

  const isOwner = user.id === auth.user.id;
  return (
    <div>
      <RenderWhen>
        <RenderWhen.If isTrue={typeLayout === 'col'}>
          <RenderWhen.If isTrue={loading && artworks.length === 0}>
            <div className="flex min-h-[400px] items-center justify-center">
              <Spinner label="loading..." />
            </div>
          </RenderWhen.If>
          <RenderWhen.If isTrue={artworks.length === 0 && !loading}>
            <NoData />
          </RenderWhen.If>
          <RenderWhen.If isTrue={artworks.length > 0}>
            <div>
              {isOwner ? (
                <ListUsecaseProfile
                  openFilter={openFilter}
                  setOpenFilter={setOpenFilter}
                  list={artworks}
                  loadMore={loadMore}
                  currentPage={currentPage}
                  // getUseCaseURL={getUseCaseURL}
                  loading={loading}
                />
              ) : (
                <ListUsecase
                  openFilter={openFilter}
                  setOpenFilter={setOpenFilter}
                  list={artworks}
                  loadMore={loadMore}
                  currentPage={currentPage}
                  // getUseCaseURL={getUseCaseURL}
                  loading={loading}
                />
              )}
            </div>
          </RenderWhen.If>
        </RenderWhen.If>
      </RenderWhen>
    </div>
  );
};

export default UserUseCase;
